import { useState, FormEvent } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    servicio: '',
    mensaje: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    if (!formData.nombre || !formData.telefono || !formData.email || !formData.servicio) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    if (formData.mensaje.length > 500) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    try {
      const formBody = new URLSearchParams();
      formBody.append('nombre', formData.nombre);
      formBody.append('telefono', formData.telefono);
      formBody.append('email', formData.email);
      formBody.append('servicio', formData.servicio);
      formBody.append('mensaje', formData.mensaje);

      const response = await fetch('https://readdy.ai/api/public/form/submit/b0e5e0e8-e0e8-4e0e-8e0e-8e0e8e0e8e0e', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          telefono: '',
          email: '',
          servicio: '',
          mensaje: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-silver-light/30 rounded-3xl p-8 md:p-10">
      <h3 className="text-2xl font-bold text-graphite mb-6">
        Solicita tu Presupuesto Gratis
      </h3>

      <form id="contacto-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label htmlFor="nombre" className="block text-sm font-semibold text-graphite mb-2">
            Nombre completo *
          </label>
          <input
            type="text"
            id="nombre"
            name="nombre"
            value={formData.nombre}
            onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
            required
            className="w-full px-4 py-3 bg-white border border-silver-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
            placeholder="Tu nombre"
          />
        </div>

        <div>
          <label htmlFor="telefono" className="block text-sm font-semibold text-graphite mb-2">
            Teléfono *
          </label>
          <input
            type="tel"
            id="telefono"
            name="telefono"
            value={formData.telefono}
            onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
            required
            className="w-full px-4 py-3 bg-white border border-silver-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
            placeholder="602 36 59 96"
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-semibold text-graphite mb-2">
            Email *
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
            className="w-full px-4 py-3 bg-white border border-silver-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
            placeholder="tu@email.com"
          />
        </div>

        <div>
          <label htmlFor="servicio" className="block text-sm font-semibold text-graphite mb-2">
            Servicio que necesitas *
          </label>
          <select
            id="servicio"
            name="servicio"
            value={formData.servicio}
            onChange={(e) => setFormData({ ...formData, servicio: e.target.value })}
            required
            className="w-full px-4 py-3 bg-white border border-silver-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all cursor-pointer"
          >
            <option value="">Selecciona un servicio</option>
            <option value="Vaciado de Pisos y Casas">Vaciado de Pisos y Casas</option>
            <option value="Vaciado de Locales Comerciales">Vaciado de Locales Comerciales</option>
            <option value="Retirada de Muebles">Retirada de Muebles y Electrodomésticos</option>
            <option value="Limpieza Síndrome de Diógenes">Limpieza por Síndrome de Diógenes</option>
            <option value="Pintura Final">Pintura Final</option>
            <option value="Pequeñas Reparaciones">Pequeñas Reparaciones</option>
            <option value="Vaciado de Trasteros">Vaciado de Trasteros</option>
            <option value="Limpieza Fin de Obra">Limpieza Fin de Obra</option>
            <option value="Desinfección y Desodorización">Desinfección y Desodorización</option>
            <option value="Otro">Otro servicio</option>
          </select>
        </div>

        <div>
          <label htmlFor="mensaje" className="block text-sm font-semibold text-graphite mb-2">
            Mensaje (máximo 500 caracteres)
          </label>
          <textarea
            id="mensaje"
            name="mensaje"
            value={formData.mensaje}
            onChange={(e) => {
              if (e.target.value.length <= 500) {
                setFormData({ ...formData, mensaje: e.target.value });
              }
            }}
            rows={4}
            maxLength={500}
            className="w-full px-4 py-3 bg-white border border-silver-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all resize-none"
            placeholder="Cuéntanos qué necesitas..."
          ></textarea>
          <p className="text-xs text-gray-medium mt-1">
            {formData.mensaje.length}/500 caracteres
          </p>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full px-8 py-4 bg-primary text-white rounded-lg font-semibold text-lg hover:bg-primary-dark hover:shadow-glow transition-all disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
        >
          {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
        </button>

        {submitStatus === 'success' && (
          <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-green-800 text-sm">
              ¡Gracias! Hemos recibido tu solicitud. Te contactaremos en breve.
            </p>
          </div>
        )}

        {submitStatus === 'error' && (
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800 text-sm">
              Ha ocurrido un error. Por favor, inténtalo de nuevo o llámanos al 602 36 59 96.
            </p>
          </div>
        )}

        <p className="text-xs text-gray-medium text-center">
          Al enviar este formulario, aceptas nuestra política de privacidad y el tratamiento de tus datos personales.
        </p>
      </form>
    </div>
  );
};

export default ContactForm;
